import { render } from "./DeleteIcon.svg?vue&type=template&id=1a162e63"
const script = {}
script.render = render

export default script